import { Head, Link, useForm } from "@inertiajs/react"

import AppLayout from "@/layouts/app-layout"
import type { BreadcrumbItem } from "@/types"

interface Activity {
  id: number
  title: string
}
interface Option {
  id: number
  name: string
}
interface Props {
  activity: Activity
  users: Option[]
  errors?: Record<string, string[]>
}

export default function New({ activity, users, errors }: Props) {
  const breadcrumbs: BreadcrumbItem[] = [
    { title: "Marketing Activities", href: "/marketing_activities" },
    { title: activity.title, href: `/marketing_activities/${activity.id}` },
    {
      title: "Employees",
      href: `/marketing_activities/${activity.id}/employees`,
    },
    {
      title: "Add",
      href: `/marketing_activities/${activity.id}/employees/new`,
    },
  ]
  const { data, setData, post, processing, transform } = useForm({
    user_id: "",
  })

  transform((data) => ({ marketing_activity_employee: data }))

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault()
    post(`/marketing_activities/${activity.id}/employees`)
  }
  return (
    <AppLayout breadcrumbs={breadcrumbs}>
      <Head title="Add Employee" />
      <div className="p-6">
        <h1 className="mb-4 text-2xl font-semibold">
          Add Employee to {activity.title}
        </h1>
        <form onSubmit={handleSubmit} className="max-w-xl space-y-4">
          <div>
            <label className="block font-medium">Employee</label>
            <select
              value={data.user_id}
              onChange={(e) => setData("user_id", e.target.value)}
              className="w-full rounded border px-3 py-2"
            >
              <option value="">Select...</option>
              {users.map((u) => (
                <option key={u.id} value={u.id}>
                  {u.name}
                </option>
              ))}
            </select>
            {errors?.user_id && (
              <p className="text-hpi-red text-sm">
                {errors.user_id.join(", ")}
              </p>
            )}
          </div>
          <div className="flex gap-4">
            <button
              type="submit"
              disabled={processing}
              className="bg-hpi-dark-blue hover:bg-hpi-blue rounded px-4 py-2 text-white disabled:opacity-50"
            >
              Add
            </button>
            <Link
              href={`/marketing_activities/${activity.id}/employees`}
              className="hover:bg-hpi-pale-gray rounded border px-4 py-2"
            >
              Cancel
            </Link>
          </div>
        </form>
      </div>
    </AppLayout>
  )
}
